import React from 'react';
import classNames from 'classnames';
import { AspectRatioBox } from '@moda/om';
import './PlaceholderCell.scss';

type PlaceholderCellProps = {
  className?: string;
  invisible?: boolean;
};

export const PlaceholderCell: React.FC<PlaceholderCellProps> = ({ className, invisible }) => {
  return (
    <AspectRatioBox
      className={classNames('PlaceholderCell', className, {
        'PlaceholderCell--invisible': invisible
      })}
      maxHeight={540}
      maxWidth={340}
    />
  );
};
